import QuestionValue from "./QuestionValue";

export default class QuestionValueTexture extends QuestionValue {
    constructor(value, name, texture) {
        super(value);

        this._name = name;
        this._texture = texture;
    }

    toString() {
        return this._name;
    }

    get texture() {
        return this._texture;
    }
}